import { FormItem } from 'vnetwork-ui'
import { getAllDepartments } from '@/modules/Employee/services'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface DepartmentSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean

    onChangeAfterHookForm?: () => void
}

const DepartmentSelectMutiple = <T extends FieldValues>({
    control,
    name,
    multiple,

    onChangeAfterHookForm,
}: DepartmentSelectProps<T>) => {
    const { data, isFetching } = useQuery({
        queryKey: [QUERY_KEYS.DEPARTMENTS],
        queryFn: getAllDepartments,
    })

    const { t } = useTranslation()

    return (
        <FormItem
            control={control}
            name={name}
            type="select"
            placeholder={t('departments')}
            options={data?.results?.map((item) => ({
                label: item.department_name,
                value: item.department_id,
            }))}
            label={t('departments')}
            multiple={multiple}
            disabled={isFetching}
            loading={isFetching}
            onChangeAfterHookForm={() => {
                onChangeAfterHookForm?.()
            }}
        />
    )
}

export default DepartmentSelectMutiple
